import { EuiFormRow } from '@equipmentshare/ds2'
import ComboBox from 'components/ComboBox/comboBox'
import { useRolesQuery, Role } from '../../../../../graphql'

export type RolePickerProps = {
	id?: string,
	disabled?: boolean,
	label?: string,
	onChange: ( id?: number, option?: Role ) => void,
	selectedRole?: Role,
	required?: boolean,
	className?: string,
}

export default function RolePicker( { label, selectedRole, onChange, ...props }: RolePickerProps ) {
	const { data, loading } = useRolesQuery()
	const roles = ( data?.roles ?? [] ) as Role[]
	const handleChange = ( r?: Role ) => onChange( r?.id, r )

	return (
		<EuiFormRow label={label ?? 'Role'}>
			<ComboBox
				isLoading={loading}
				setSelectedOption={handleChange}
				selectedOption={selectedRole}
				data={roles}
				getName={( r ) => r.name}
				async={false}
				{...props}
			/>
		</EuiFormRow>
	)
}
